export default "__VITE_ASSET__BuZzVTEl__"